import React, { useState } from "react";
import withMotion from "../../../Utils/withMotion";
import "../Blog.scss";
import ReactPagination from "react-js-pagination";
import { useHistory } from "react-router-dom";

//Shapes
import { TitleBar } from "../../../Shapes/Shapes";

//Panels
import Sidebar from "../Sidebar/Sidebar";

//Data
import { blogs } from "./Blogs";

//Utils
import { mapBlogs } from "./utils";
import SEO from "../../../SEO";

const Blog = (props) => {
  const { params } = props.match;
  const [current] = useState(parseInt(params.page));
  const currentPage = parseInt(params.page);
  const history = useHistory();

  let filteredBlogs = [];

  const seoInfo = [
    {
      category: "installation",
      blogTitle: "Installation Blogs",
      seoTitle: "Blogs About Pavingstone Installation | Pacific Pavingstone",
      seoDescription:
        "Read our blogs to gain ideas and inspiration around pavingstone installation. Have additional questions? Contact us today!",
      seoCanonical:
        "https://pacificpavingstone.com/blog/categories/installation/1",
    },
    {
      category: "paving-stones",
      blogTitle: "Paving Stones Blogs",
      seoTitle: "Blogs About Pavingstone | Pacific Pavingstone",
      seoDescription:
        "Read our blogs to gain ideas and inspiration around paving stones. Have additional questions? Contact us today!",
      seoCanonical:
        "https://pacificpavingstone.com/blog/categories/paving-stones/1",
    },
    {
      category: "contractors",
      blogTitle: "Contractors Blog",
      seoTitle: "Contractor Blog | Pacific Pavingstone",
      seoDescription:
        "Read our blogs to gain ideas and inspiration around contracting work. Have additional questions? Contact us today!",
      seoCanonical:
        "https://pacificpavingstone.com/blog/categories/contractors/1",
    },
    {
      category: "driveways",
      blogTitle: "Driveway Pavers Blogs",
      seoTitle: "Blogs About Driveway Pavers| Pacific Pavingstone",
      seoDescription:
        "Read our blogs to gain ideas and inspiration around paver driveways. Have additional questions? Contact us today!",
      seoCanonical:
        "https://pacificpavingstone.com/blog/categories/driveways/1",
    },
    {
      category: "patios",
      blogTitle: "Patio Pavers Blogs",
      seoTitle: "Blogs About Patio Pavers | Pacific Pavingstone",
      seoDescription:
        "Read our blogs to gain ideas and inspiration around outdoor patio paving. Have additional questions? Contact us today!",
      seoCanonical:
        "https://pacificpavingstone.com/blog/categories/patios/1",
    },
    {
      category: "walkways",
      blogTitle: "Paver Walkways Blogs",
      seoTitle: "Blogs About Paver Walkways | Pacific Pavingstone",
      seoDescription:
        "Read our blogs to gain ideas and inspiration around paver walkways. Have additional questions? Contact us today!",
      seoCanonical:
        "https://pacificpavingstone.com/blog/categories/walkways/1",
    },
    {
      category: "choosing-a-paving-material",
      blogTitle: "Choosing Paving Materials Blogs",
      seoTitle: "Blogs About Paving Materials | Pacific Pavingstone",
      seoDescription:
        "Read our blogs to gain ideas and inspiration around paving materials. Have additional questions? Contact us today!",
      seoCanonical:
        "https://pacificpavingstone.com/blog/categories/choosing-a-paving-material/1",
    },
    {
      category: "retaining-walls",
      blogTitle: "Retaining Walls Blogs",
      seoTitle: "Blogs About Garden Retaining Walls | Pacific Pavingstone",
      seoDescription:
        "Read our blogs to gain ideas and inspiration around garden retaining walls. Have additional questions? Contact us today!",
      seoCanonical:
        "https://pacificpavingstone.com/blog/categories/retaining-walls/1",
    },
    {
      category: "permeable-pavers",
      blogTitle: "Permeable Pavers Blogs",
      seoTitle: "Blogs About Permeable Pavers | Pacific Pavingstone",
      seoDescription:
        "Read our blogs to gain ideas and inspiration around Permeable Pavers. Have additional questions? Contact us today!",
      seoCanonical:
        "https://pacificpavingstone.com/blog/categories/permeable-pavers/1",
    },
  ];

  const blogCategory = params.category;
  console.log("Categories", params);

  blogs.forEach((blog) => {
    blog.categories.forEach((category) => {
      if (category === blogCategory) {
        filteredBlogs.push(blog);
      }
    });
  });

  const blogLength = filteredBlogs.length;

  return (
    <>
      {seoInfo.map((x) => {
        if (x.category === params.category) {
          return (
            <>
              <SEO
                title={x.seoTitle}
                description={x.seoDescription}
                profileURL={x.seoCanonical}
                type="website"
              />
              <div className="container-fluid page-pagination">
                <div className="row justify-content-center mb-5">
                  <div className="col-9 col-sm-6 col-md-4 col-lg-3 text-center">
                    <h1 className="text-uppercase">{x.blogTitle}</h1>
                    <TitleBar />
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-9 col-md-9 col-lg-6">
                    {mapBlogs(currentPage, filteredBlogs)}
                  </div>
                  <Sidebar />
                </div>
                <div className="row justify-content-center mb-5">
                  <ReactPagination
                    innerClass="pagination pagination-lg justify-content-center"
                    itemClass="page-item"
                    linkClass="page-link"
                    activePage={currentPage}
                    itemsCountPerPage={5}
                    totalItemsCount={blogLength}
                    pageRangeDisplayed={3}
                    onChange={(page) => history.push(`/blog/categories/${x.category}/${page}`)}
                  />
                </div>
              </div>
            </>
          );
        }
        return null
      })}
    </>
  );
};

export default withMotion(Blog);
